import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { Supplier } from '../../classes/supplier';
import { SupplierService } from '../../services/supplier';
import { AuthService } from '../../services/auth';
import { User } from '../../classes/user';
import { emailListError, fiscalCodeError, isItalianFiscalCode, joinEmails, normalizeEmails, normalizeFiscalCode, singleEmailError, splitEmails } from '../../utils/supplierValidation';

@Component({
    selector: 'app-supplier-update',
    templateUrl: './supplier-update.component.html',
    styleUrls: ['./supplier-update.component.css']
})
export class SupplierUpdateComponent implements OnInit {
    user: User = new User();
    supplier: Supplier = new Supplier();
    emails: string[] = [''];
    foreignSupplier: boolean = false;
    submitted: boolean = false;
    loadingCondition: boolean = false;

    constructor(private route: ActivatedRoute,
                private router: Router,
                private authService: AuthService,
                private supplierService: SupplierService) {
    }

    ngOnInit(): void {
        this.authService.isUserSignedIn()
            .subscribe({
                next: () => {
                    this.authService.getUser()
                        .subscribe({
                            next: (user: any) => {
                                this.user = user;
                                if (this.user.FKIDUserRole !== 1) {
                                    this.router.navigate(['/dashboard']);
                                    return;
                                }
                                this.loadSupplier();
                            },
                            error: () => {
                                this.router.navigate(['/login']);
                            }
                        });
                },
                error: () => {
                    this.router.navigate(['/login']);
                }
            });
    }

    private loadSupplier(): void {
        this.route.paramMap.subscribe(params => {
            this.supplierService.getByID(params.get('id'))
                .subscribe({
                    next: (supplier: Supplier) => {
                        this.supplier = supplier;
                        this.foreignSupplier = !isItalianFiscalCode(supplier.CF || '');
                        const parsedEmails = splitEmails(supplier.Email);
                        this.emails = parsedEmails.length > 0 ? parsedEmails : [''];
                    },
                    error: (err: HttpErrorResponse) => {
                        console.log(err);
                    }
                });
        });
    }

    get cfError(): string | null {
        return this.submitted ? fiscalCodeError(this.supplier.CF, this.foreignSupplier) : null;
    }

    get emailFieldError(): string | null {
        return this.submitted ? emailListError(this.emails) : null;
    }

    trackByIndex(index: number): number {
        return index;
    }

    addEmail(): void {
        this.emails.push('');
    }

    removeEmail(index: number): void {
        if (this.emails.length > 1) {
            this.emails.splice(index, 1);
        }
    }

    onEmailChange(index: number, value: string): void {
        if ((value || '').includes(';')) {
            const parts = value.split(';').map(part => part.trim()).filter(part => part.length > 0);
            this.emails.splice(index, 1, ...(parts.length > 0 ? parts : ['']));
        }
    }

    hasEmailItemError(index: number): boolean {
        return this.submitted && singleEmailError(this.emails[index]) !== null;
    }

    saveAndGoToList() {
        this.submitted = true;
        if (this.cfError || this.emailFieldError) {
            return;
        }
        this.supplier.CF = this.foreignSupplier
            ? this.supplier.CF.trim().replace(/\s+/g, ' ').toUpperCase()
            : normalizeFiscalCode(this.supplier.CF);
        this.supplier.Email = normalizeEmails(joinEmails(this.emails));
        this.loadingCondition = true;
        this.supplierService.update(this.supplier, this.foreignSupplier)
            .subscribe({
                next: () => {
                    this.loadingCondition = false;
                    this.router.navigate(['/fornitori']);
                },
                error: (err: HttpErrorResponse) => {
                    this.loadingCondition = false;
                    console.log(err);
                }
            });
    }

}
